// Import model
import { PaymentTerms } from '../models/PaymentTerms';

// Import base class serializer
import { EntityOwnedModelSerializer } from './EntityOwnedModelSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PaymentTerms - handles JSON serialization and deserialization with type validation
 */
export class PaymentTermsSerializer {
  /**
   * Deserializes a JSON string into a PaymentTerms instance
   */
  static deserialize(json: string): PaymentTerms {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PaymentTerms instance
   */
  static fromObject(obj: any): PaymentTerms {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PaymentTerms');
    }


    const instance: PaymentTerms = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      discount: obj['discount'] as number | undefined,
      downPayment: obj['downPayment'] as number | undefined,
      downPaymentPercentage: obj['downPaymentPercentage'] as number | undefined,
      frequency: obj['frequency'] as string | undefined,
      installments: obj['installments'] as number | undefined,
      interestRatePercentage: obj['interestRatePercentage'] as number | undefined,
      isActive: obj['isActive'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PaymentTerms instances
   */
  static deserializeArray(json: string): PaymentTerms[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PaymentTerms instance to a JSON string
   */
  static serialize(instance: PaymentTerms): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PaymentTerms instance to a plain object
   */
  static toObject(instance: PaymentTerms): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'discount': instance.discount,
      'downPayment': instance.downPayment,
      'downPaymentPercentage': instance.downPaymentPercentage,
      'frequency': instance.frequency,
      'installments': instance.installments,
      'interestRatePercentage': instance.interestRatePercentage,
      'isActive': instance.isActive,
    };
  }

  /**
   * Serializes an array of PaymentTerms instances to a JSON string
   */
  static serializeArray(instances: PaymentTerms[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
